import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import { grey } from '@material-ui/core/colors';

import {FormControl, Button, Checkbox, TextField} from '@material-ui/core';
import {Grid, Typography, Container, Box, Select, MenuItem} from '@material-ui/core';
import {Table, TableBody, TableCell, TableHead, TableRow} from '@material-ui/core';

//import {Tab, Tabs} from '@material-ui/core';
//import {TabPanel} from '../../../components/TabPanel'

import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {ApplicationBar} from '../../../components/ApplicationBar';

//import Logo from '../../components/Logo';

import {TabbedMenu} from './TabbedMenu';

import {Dialog} from '../../../components/Dialog';

import {getBase64ID, getIndexByID} from '../../../api/helpers'; //, getIndexByID, base64toGuid, sortByName
import { DispatchersListEditor } from './DispatchersListEditor';
import { ExternalNetworksListEditor } from './ExternalNetworksListEditor';

import { EditDispatcherDialog } from './EditDispatcherDialog';
//import { EditPasswordPolicyDialog } from './EditPasswordPolicyDialog';
import { EditPasswordPolicyDialog } from '../../components/EditPasswordPolicyDialog';

import { UPLOAD_MAX_FILE_SIZE } from '../../../FleetConsole/api/ServerApi';
import { TemplatesListEditor } from './TemplatesListEditor';
import { EditFieldTemplateDialog } from './EditFieldTemplateDialog';
import { EditExternalNetworkDialog } from './EditExternalNetworkDialog';
//import { Label } from '@material-ui/icons';

import * as dev from '../../../api/dev'


class ServerSettings_ extends React.Component {
    
    constructor(props){
        super(props);

        this.state = {
            serverSettings: this.props.serverSettings,

            currentDispatcherID: '',
            currentExternalNetworkID: '',

            //currentNetworkID: '',
            //currentUserID: '',
            //currentGroupID: '',
           // currentProfileID: '',
            //currentStatusID: '',
            //currentDeviceID: '',
            selectedTab: 'dispatchers',
            dispatcherEditor: {
                open: false,
                action: '', //add|edit
                dispatcherID: '',
                dispatcher: {}
            },
            passwordPolicyEditor: {
                open: false,
                passwordPolicy: {}
            },
            panelsExpanded:{
                Alarms: true,
                SMTP: false
            },
            fieldTemplateEditor:{
                action: '',
                open: false,
                templateID: '',
                template: {}
            },
            externalNetworkEditor: {
                open: false,
                externalNetwork: {}
            }
        }

        this.handleAction = this.handleAction.bind(this)
        this.handleTabClick = this.handleTabClick.bind(this)


        this.handleInput = this.handleInput.bind(this)
        this.imageRef = React.createRef();

        this.handleLogoClick = this.handleLogoClick.bind(this)
    }

    componentDidMount(){
        
    }
    componentDidUpdate(){
        if(this.props.serverSettings && !this.state.serverSettings){
            this.setState({serverSettings: this.props.serverSettings})
            console.log('Open server settings editor')
            console.log(this.props.serverSettings)
        }
    }


    handleDispatcherSelect(dispatcherID){
        this.setState({currentDispatcherID: dispatcherID})
    }

    handleExternalNetworkSelect(externalNetworkID){
        this.setState({currentExternalNetworkID: externalNetworkID})
    }

    getNetwork(networkID){
        for(let i=0; i<this.props.networks.length; i++){
            if(this.props.networks[i].ID === networkID) return this.props.networks[i];
        }
        return null
    }
    
    checkLicense(licenseName){
        return this.props.onAction({type: 'LICENSE_CHECK', licenseName: licenseName})
    }

    handleTabClick(tab){
        this.setState({selectedTab: tab});
    }

    handleButtonSave(){
        this.props.onAction({type:'SERVER_SETTINGS_EDITOR_SAVE', serverSettings: this.state.serverSettings})
    }

    handleButtonCancel(){
        this.props.onAction({type:'SERVER_SETTINGS_EDITOR_CLOSE'})
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value

        //debugger

        const serverSettings = {...this.state.serverSettings}

        switch(event.target.name){

            case 'TotalProcessorThreshold':
            case 'TotalProcessorTimeout':
            case 'TotalProcessorAlarm': 
            case 'TotalProcessorEmail':
            case 'TotalMemoryThreshold':
            case 'TotalMemoryTimeout':
            case 'TotalMemoryAlarm':
            case 'TotalMemoryEmail':
            case 'DiskFreeSpaceThreshold':
            case 'DiskFreeSpaceTimeout':
            case 'DiskFreeSpaceAlarm':          
            case 'DiskFreeSpaceEmail':
            case 'DiskLoadThreshold':
            case 'DiskLoadTimeout':
            case 'DiskLoadAlarm':          
            case 'DiskLoadEmail':
            case 'NetworkThreshold':
            case 'NetworkTimeout':
            case 'NetworkAlarm':          
            case 'NetworkEmail':
            case 'DatabaseSizeThreshold':
            case 'DatabaseSizeTimeout':
            case 'DatabaseSizeAlarm': 
            case 'DatabaseSizeEmail':
            //case 'DmrNetworkAlert':
            //case 'DmrNetworkEmail':
            case 'DmrRepeaterDisconnectAlarm':
            case 'DmrRepeaterDisconnectEmail':
            case 'SmtpEnabled':
            case 'SmtpServerAddress':
            case 'SmtpServerPort':
            case 'SmtpEnableSSL':
            case 'SmtpLogin':
            case 'SmtpPassword':
            case 'SmtpAccountName':
            case 'SmtpAccountAddress':
            case 'SmtpMessageSubject':
            case 'SmtpMessageToAddress':
                serverSettings.ServerData.StatisticsSettings[event.target.name] = val
                break

            default:
                serverSettings.ServerData[event.target.name] = val
        }
        
        //, [event.target.name]: val}
        this.setState({serverSettings: serverSettings, ...changed})
    }

    
    handleAction(action){

        const {t} = this.props

        console.log('ServerSettings handleAction')
        console.log(action)

        if(this.state.serverSettings===undefined){
            return
        }

        switch(action.type){
            case 'DISPATCHER_EDITOR_SAVE': {
                    let dispatcher = {...action.dispatcher}
                    let serverSettings = {...this.state.serverSettings}

                    console.log('dispatcher')
                    console.log(dispatcher)

                    if(!dispatcher.DispatcherData.ID) dispatcher.DispatcherData.ID = getBase64ID()

                    //let dispatcherIndex = getIndexByID(dispatcher.DispatcherData.ID, serverSettings.Dispatchers)
                    const dispatcherIndex = serverSettings.Dispatchers.findIndex(item=>item.DispatcherData.ID===dispatcher.DispatcherData.ID)

                    console.log(dispatcher.DispatcherData.ID)
                    console.log('dispatcher.DispatcherData.ID')
                    console.log('dispatcherIndex')
                    console.log(dispatcherIndex)

                    //debugger    
                    if(dispatcherIndex===-1){
                        serverSettings.Dispatchers.push(dispatcher);
                    }else{
                        serverSettings.Dispatchers[dispatcherIndex] = dispatcher
                    }
                    console.log('serverSettings')
                    console.log(serverSettings)
                    this.setState({serverSettings: serverSettings, dispatcherEditor: {open: false, action:'', dispatcherID:'', dispatcher:{}}})
                }
                break;  

            case 'DISPATCHER_EDITOR_CLOSE':
                this.setState({dispatcherEditor: {open: false, action:'', dispatcherID:'', dispatcher:{}}})
                break;

            case 'DISPATCHER_EDITOR_OPEN_EDIT': {
                    //debugger
                    //let dispatchers = this.state.serverSettings.Dispatchers
                    
                    let dispatchers = this.state.serverSettings.Dispatchers.filter(
                        item => item.DispatcherData.ID===action.dispatcherID
                    )
                    let dispatcher = dispatchers[0]

                    console.log('dispatcher')
                    console.log(dispatcher)
                    console.log('this.state')
                    console.log(this.state)
                    //debugger

                    this.setState({dispatcherEditor: {
                        open: true,
                        action: 'edit', //add|edit
                        dispatcherID: action.dispatcherID,
                        dispatcher: dispatcher
                    }})

                }
                break
            case 'DISPATCHER_EDITOR_OPEN_ADD': 
                this.setState({dispatcherEditor: {
                    open: true,
                    action: 'add', //add|edit
                    dispatcherID: action.dispatcherID,
                    dispatcher: {
                        DispatcherData:{
                            ID: '',
                            Login: '',
                            Name: '',
                            Permissions: 0,
                            Priority:0,
                            AllowAdministrativeMode: false,
                            AllowManageServer: false,
                            SingleLogin: 0,
                            RadioID: 0
                        },
                        Password:'',
                        AllowedNetworks: []
                    },
                }})
                break
            case 'DISPATCHER_EDITOR_DELETE': {
                    const {dispatcherID} = action;
                    let serverSettings = {...this.state.serverSettings}
                    let dispatcherIndex = this.state.serverSettings.Dispatchers.findIndex(
                        item => item.DispatcherData.ID===dispatcherID
                    )

                    //console.log('DISPATCHER_EDITOR_DELETE')
                    //console.log(dispatcherIndex)
                    //console.log(this.state.serverSettings.Dispatchers)
                    let name =  dispatcherIndex!==-1 ? this.state.serverSettings.Dispatchers[dispatcherIndex].DispatcherData.Name : ''

                    let message = t('DeleteDispatcher?').replace('?', ': '+name+'?')

                    this.props.onAction({
                        type: 'CONFIRM_DIALOG', 
                        message: message,
                        onConfirm: ()=>{
                            if(dispatcherIndex!==-1){
                                serverSettings.Dispatchers.splice(dispatcherIndex, 1)
                                this.setState({serverSettings: serverSettings})   
                            }
                        }
                    })

                }
                break;
            case 'DISPATCHER_EDITOR_INPUT':{
                    const {event, dispatcherID} = action;
                    let serverSettings = {...this.state.serverSettings}
                    //const dispatcherIndex = getIndexByID(dispatcherID, serverSettings.Dispatchers)

                    let dispatcherIndex = this.state.serverSettings.Dispatchers.findIndex(
                        item => item.DispatcherData.ID===dispatcherID
                    )

                    if(dispatcherIndex!==null){
                        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
                        const dispatcher = {...serverSettings.Dispatchers[dispatcherIndex]}
                        dispatcher.DispatcherData[event.target.name] = val
   
                        serverSettings.Dispatchers[dispatcherIndex] = dispatcher
                        this.setState({serverSettings: serverSettings})
                    }
                }
                break;

            case 'SHOW_PASSWORD_POLICY_DIALOG':
                //console.log('SHOW_PASSWORD_POLICY_DIALOG')
                this.setState({passwordPolicyEditor:{
                    open:true,
                    passwordPolicy: this.state.serverSettings.ServerData.PasswordPolicy
                }})
                break

            case 'PASSWORD_POLICY_EDITOR_CLOSE':
                //console.log('PASSWORD_POLICY_EDITOR_CLOSE')
                this.setState({passwordPolicyEditor:{
                    open:false,
                    passwordPolicy: {}
                }})
                break

            case 'PASSWORD_POLICY_EDITOR_SAVE':{
                let {passwordPolicy} = action
                //console.log('PASSWORD_POLICY_EDITOR_SAVE')
                //console.log(action)
                //console.log(this.state.serverSettings.ServerData.PasswordPolicy)

                let serverSettings = {...this.state.serverSettings}
                serverSettings.ServerData.PasswordPolicy = passwordPolicy

                this.setState({serverSettings: serverSettings, 
                              passwordPolicyEditor:{open:false, passwordPolicy: {}}
                })
                break
            }

            case 'EXTERNAL_NETWORK_EDITOR_OPEN_ADD':{
                //console.log('action')
                //console.log(action)

                if(action.externalNetwork){
                    this.setState({externalNetworkEditor: {
                        action: 'add', //add|edit
                        open: true,
                        externalNetworkID: action.externalNetworkID,
                        externalNetwork: action.externalNetwork
                    }})
                }

                break
            }

            case 'EXTERNAL_NETWORK_EDITOR_OPEN_EDIT':{
                //console.log('action')
                //console.log(action)

                let index = getIndexByID(action.externalNetworkID, this.state.serverSettings.ExternalNetworks)

                let net = null 
                if(index!==null){
                    net = this.state.serverSettings.ExternalNetworks[index]
                    if(net){
                        this.setState({externalNetworkEditor: {
                            action: 'edit', //add|edit
                            open: true,
                            externalNetworkID: action.externalNetworkID,
                            externalNetwork: {...net}
                        }})
                    }
                }
                
                break
            }

            case 'EXTERNAL_NETWORK_EDITOR_SAVE':{
                let {externalNetwork} = action

                //console.log('externalNetwork')
                //console.log(externalNetwork)

                let serverSettings = {...this.state.serverSettings}
                if(!externalNetwork.ID) externalNetwork.ID = getBase64ID()
                
                let index = getIndexByID(externalNetwork.ID, serverSettings.ExternalNetworks)

                //console.log('index='+index)

                //console.log('serverSettings')
                //console.log(serverSettings)
                //debugger
                if(index===null){
                    serverSettings.ExternalNetworks.push(externalNetwork);
                }else{
                    serverSettings.ExternalNetworks[index] = externalNetwork
                }
                this.setState({serverSettings: serverSettings, externalNetworkEditor: {open: false, action:'', externalNetwork:{}}})

                break
            }

            case 'EXTERNAL_NETWORK_EDITOR_DELETE':{
                //console.error(action)
                const {externalNetworkID} = action;
                let serverSettings = {...this.state.serverSettings}
                let index = getIndexByID(externalNetworkID, serverSettings.ExternalNetworks)
                if(index!==null){
                    serverSettings.ExternalNetworks.splice(index, 1)
                    this.setState({serverSettings: serverSettings})   
                }
                break
            }

            case 'EXTERNAL_NETWORK_EDITOR_CLOSE':{
                this.setState({externalNetworkEditor: {
                    action: '', //add|edit
                    open: false,
                    externalNetworkID: '',
                    externalNetwork: {}
                }})
                break
            }

            case 'FIELD_TEMPLATE_EDITOR_OPEN_EDIT':{

                let templates = this.state.serverSettings.FieldTemplates.filter(item => item.ID===action.templateID)
                let template = templates[0]

                //console.log('template')
                //console.log(template)
                //debugger

                this.setState({fieldTemplateEditor: {
                    action: 'edit', //add|edit
                    open: true,
                    templateID: action.templateID,
                    template: {...template}
                }})

                break
            }

            case 'FIELD_TEMPLATE_EDITOR_OPEN_ADD':{

                let template = {
                    ID: '',
                    Name: t('NewTemplate'),
                    Type: 3,
                    Fields: []
                }

                this.setState({fieldTemplateEditor: {
                    action: 'add', //add|edit
                    open: true,
                    templateID: '',
                    template: template
                }})

                break
            }


            case 'FIELD_TEMPLATE_EDITOR_SAVE':{
                let {template} = action

                if(!template.ID) template.ID = getBase64ID()
                
                let serverSettings = {...this.state.serverSettings}

                let index = getIndexByID(template.ID, serverSettings.FieldTemplates, 'ID')

                //console.log('FIELD_TEMPLATE_EDITOR_SAVE')
                //console.log('template')
                //console.log(template)
                //console.log('index')
                //console.log(index)

                if(index!==null){
                    console.log('set')
                    serverSettings.FieldTemplates[index] = template
                }else{
                    console.log('push')
                    serverSettings.FieldTemplates.push(template)
                }

                //console.log('serverSettings')
                //console.log(serverSettings)

                this.setState({
                    serverSettings: serverSettings, 
                    fieldTemplateEditor:{
                        open:false, 
                        action:'', 
                        templateID:'', 
                        template: {}}
                })

                break
            }

            case 'FIELD_TEMPLATE_EDITOR_DELETE':{
                console.error(action)
                
                const {templateID} = action;
                let serverSettings = {...this.state.serverSettings}
                let index = getIndexByID(templateID, serverSettings.FieldTemplates)
                if(index!==null){
                    serverSettings.FieldTemplates.splice(index, 1)
                    this.setState({serverSettings: serverSettings})   
                }
                
                break
            }

            case 'FIELD_TEMPLATE_EDITOR_CLOSE':{
                this.setState({fieldTemplateEditor: {
                    action: '', //add|edit
                    open: false,
                    templateID: '',
                    template: {}
                }})
                break
            }

            case 'CONFIRM_DIALOG':
            case 'ALERT_DIALOG':
            case 'LOGOUT':
                this.props.onAction(action)
                break


            case 'LICENSE_CHECK':
                return this.props.onAction(action)

            default:
                console.error(action)
                dev.alert('ServerSettings handleAction '+ action.type)
                
        }
    }


    handleSelectLogo(){
        const fileInput = this.imageRef.current
        if(fileInput){
            if(fileInput.files){
                const file = fileInput.files[0];
                if(file.size > UPLOAD_MAX_FILE_SIZE){
                    this.props.onAction({type:'ALERT_DIALOG', message: 'Max file size exceeded: ' + UPLOAD_MAX_FILE_SIZE})
                }else{
                    const reader = new FileReader();
                    reader.onload = e => { this.setLogo(e.target.result) }
                    reader.readAsDataURL(file)

                }
            }
        }
    }

    setLogo(fileStream){
        const serverSettings = {...this.state.serverSettings}

        const pos = fileStream.indexOf(';base64,')

        serverSettings.ServerData.LogoStream = fileStream.substring(pos+8)

        this.setState({serverSettings: serverSettings})
    }


    handleLogoClick(){       
        const fileInput = this.imageRef.current
        if(fileInput){
            fileInput.click()
        }
    }

    customTab(){
        let t = this.props.t

        const margin = {margin:'16px auto 8px auto'}

       const logoEnabled = Boolean(this.state.serverSettings.ServerData.UseCustomLogo)
       const hideDemoLink = Boolean(this.state.serverSettings.ServerData.HideDemoLink)
       const enableAllowedServers = Boolean(this.state.serverSettings.ServerData.EnableAllowedServers)

       const hasLogo = this.state.serverSettings.ServerData.LogoStream ? true : false
       const imgStyle = logoEnabled ?
            {border:'1px solid grey', cursor:'pointer', width:280, height:40}
            :
            {border:'1px solid lightgrey', width:280, height:40}

        const exampleStyle = {fontSize:'x-small', color:'grey'}


        return(
            <>

            <Box textAlign="left" style={{...margin, maxWidth: 600}}>
                <Grid container>
                    <Grid item xs={5}>
                        <FormControl>
                            <label>
                                <Checkbox color="primary" 
                                    checked={logoEnabled}
                                    onChange={this.handleInput}
                                    name="UseCustomLogo"
                                    />
                                    {t('ClientLogo')}
                            </label>
                        </FormControl>
                    </Grid>
                    <Grid item xs={7}>
                        {hasLogo?
                        <img alt="Logo" style={imgStyle} onClick={this.handleLogoClick}
                            src={"data:image/jpg;base64,"+ this.state.serverSettings.ServerData.LogoStream} />
                        :''
                        }
                        <input disabled={!logoEnabled} type="file" style={{display:!hasLogo?'':'none'}} ref={this.imageRef} 
                                        accept=".gif,.jpg,.jpeg,.png"   
                                        onChange={this.handleSelectLogo.bind(this)} />
                    </Grid>
                </Grid>
            </Box>


            <Box textAlign="left" style={{...margin, maxWidth: 600}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={hideDemoLink}
                            onChange={this.handleInput}
                            name="HideDemoLink"
                            />
                            {t('HideDemoLink')}
                    </label>
                </FormControl>
            </Box>


            <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                <Grid container>
                    <Grid item xs={5} style={{marginTop:29}}>
                        <FormControl style={{minWidth:400}}>
                            <label>
                                <Checkbox color="primary" 
                                    checked={enableAllowedServers}
                                    onChange={this.handleInput}
                                    name="EnableAllowedServers"
                                    />
                                    {t('AllowedServers')}
                            </label>
                        </FormControl>
                    </Grid>
                    <Grid item xs={7}>
                        <TextField name="AllowedServers" margin="normal" 
                            style={{width:'100%'}}
                            disabled={!this.state.serverSettings.ServerData.EnableAllowedServers}
                            autoComplete="new-password"
                            label={t('AllowedServers')}
                            value={this.state.serverSettings.ServerData.AllowedServers}
                            onChange={this.handleInput}
                            />
                        <Typography style={exampleStyle}>{t('Example')}: network1=192.168.1.2:10001; network1=192.168.1.2:10002</Typography>
                    </Grid>
                </Grid>
            </Box>
            


            <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                <Grid container>
                    <Grid item xs={5}>
                        {t('LocationService')}
                    </Grid>
                    <Grid item xs={7}>

                        <Select
                            value={this.state.serverSettings.ServerData.MapSystem}
                            onChange={this.handleInput}
                            name='MapSystem'>
                                <MenuItem key={0} value={0}>Google Map</MenuItem>
                                <MenuItem key={1} value={1}>OpenStreetMap</MenuItem>
                                <MenuItem key={2} value={2}>Custom OSM Server</MenuItem>
                        </Select>

                        <TextField name="CustomOSM" margin="normal" 
                            style={{width:'100%'}}
                            autoComplete="new-password"
                            label={t('CustomOSM')}
                            value={this.state.serverSettings.ServerData.CustomOSM}
                            onChange={this.handleInput}
                            />

                    </Grid>
                </Grid>
            </Box>


            </>

        )

    }

    deviceDefaultsTab(){

        let t = this.props.t

        const margin = {margin:'16px auto 8px auto'}

        return(
            <>

            <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                <Grid container>
                    <Grid item xs={5} style={{marginTop:5}}>
                        {t('PreventCPUSleep')}
                    </Grid>
                    <Grid item xs={7}>

                        <Select
                            value={this.state.serverSettings.ServerData.PreventCPUSleep}
                            onChange={this.handleInput}
                            name='PreventCPUSleep'>
                                <MenuItem key={0} value={0}>{t('SetOnDevice')}</MenuItem>
                                <MenuItem key={1} value={1}>{t('On')}</MenuItem>
                                <MenuItem key={2} value={2}>{t('Off')}</MenuItem>
                        </Select>

                    </Grid>
                </Grid>
            </Box>

            <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                <Grid container>
                    <Grid item xs={5} style={{marginTop:5}}>
                        {t('VideoResolution')}
                    </Grid>
                    <Grid item xs={7}>

                        <Select
                            value={this.state.serverSettings.ServerData.VideoResolution}
                            onChange={this.handleInput}
                            name='VideoResolution'>
                                <MenuItem key={1} value={1}>320 x 240</MenuItem>
                                <MenuItem key={2} value={2}>640 x 480</MenuItem>
                        </Select>

                    </Grid>
                </Grid>
            </Box>

            <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                <Grid container>
                    <Grid item xs={5} style={{marginTop:5}}>
                        {t('VoiceQuality')}
                    </Grid>
                    <Grid item xs={7}>

                        <Select
                            value={this.state.serverSettings.ServerData.VoiceQuality}
                            onChange={this.handleInput}
                            name='VoiceQuality'>
                                <MenuItem key={1} value={1}>Narrow Band (8khz)</MenuItem>
                                <MenuItem key={2} value={2}>Wide Band (16KHz)</MenuItem>
                                <MenuItem key={3} value={3}>Wide Band (24KHz)</MenuItem>
                                <MenuItem key={4} value={4}>Full Band (48KHz)</MenuItem>
                        </Select>

                    </Grid>
                </Grid>
            </Box>

            </>
        )

    }

    apiTab(){

        let t = this.props.t

        const margin = {margin:'16px auto 8px auto'}
        
        let langs = Object.keys(this.state.serverSettings.WebLocales);
        console.log('langs')
        console.log(langs)

        console.log('this.state.serverSettings.ServerData')
        console.log(this.state.serverSettings.ServerData)

        return(
            <>

            <Box textAlign="left" style={{...margin,  maxWidth: 650}}>
                <Grid container>
                    <Grid item xs={5} style={{marginTop:5}}>
                        {t('WebSocketProtocol')}
                    </Grid>
                    <Grid item xs={7}>

                        <Select
                            value={this.state.serverSettings.ServerData.WebProtocol}
                            onChange={this.handleInput}
                            name='WebProtocol'>
                                <MenuItem key={0} value={0}>http</MenuItem>
                                <MenuItem key={1} value={1}>https</MenuItem>
                        </Select>

                    </Grid>
                </Grid>
            </Box>


            <Box textAlign="left" style={{...margin,  maxWidth: 650}}>
                <Grid container>
                    <Grid item xs={5} style={{marginTop:5}}>
                        {t('WebCertificateSerial')}
                    </Grid>
                    <Grid item xs={7}>

                        <TextField name="WebCertificateSerial" 
                            margin="normal" 
                            hiddenLabel
                            size="small"
                            style={{width:'100%', margin:0}}
                            autoComplete="new-password"
                            value={this.state.serverSettings.ServerData.WebCertificateSerial}
                            onChange={this.handleInput}
                            />

                    </Grid>
                </Grid>
            </Box>

            <Box textAlign="left" style={{...margin,  maxWidth: 650}}>
                <Grid container>
                    <Grid item xs={5} style={{marginTop:5}}>
                        {t('Language')}
                    </Grid>
                    <Grid item xs={7}>

                        <Select
                            value={this.state.serverSettings.ServerData.WebLocale}
                            onChange={this.handleInput}
                            name='WebLocale'>
                            {langs.map(key=>{
                                let item = this.state.serverSettings.WebLocales[key]
                                console.log('key='+key)
                                console.log(item)
                                return(
                                    <MenuItem key={key} value={key}>{item.name}</MenuItem>
                                )
                            })}
                                
                        </Select>

                    </Grid>
                </Grid>
            </Box>

            </>
        )

    }

    dmrTab(){

        let externalNetworkDialog = this.state.externalNetworkEditor.open ? (
            <EditExternalNetworkDialog 
                {...this.state.externalNetworkEditor} 
                onAction={this.handleAction} />
        ) : ''

        return(
            <>
            <ExternalNetworksListEditor
                    externalNetworks={this.state.serverSettings.ExternalNetworks}
                    selectedNetworkID={this.state.currentExternalNetworkID}
                    onExternalNetworkSelect={this.handleExternalNetworkSelect.bind(this)}
                    onAction={this.handleAction} />
            {externalNetworkDialog} 
            </>
        )
    }

    
    togglePanel(event, expanded, panel){

        this.setState(state => {
            state.panelsExpanded[panel] = expanded
            return state
        })

    }

    systemMonitoringTab(){
        let t = this.props.t

        const margin = {margin:'0 auto 10px auto'}
        const margin2 = {margin:'0 0 8px 0'}

        const statisticsSettings = this.state.serverSettings.ServerData.StatisticsSettings

        console.log('statisticsSettings')
        console.log(statisticsSettings)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            }
        };

        return (
            <>
            
            <ExpansionPanel 
                expanded={this.state.panelsExpanded.Alarms} 
                onChange={(event, expanded) => this.togglePanel(event, expanded, 'Alarms')}>
                <ExpansionPanelSummary style={{background: grey[300]}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{t('Alarms')}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{display: 'block'}}>


                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell style={styles.head}>{t('AlarmType')}</TableCell>
                                <TableCell align='center' style={{...styles.head, width:40}}>{t('Criteria')}</TableCell>
                                <TableCell style={{...styles.head, width:'15%'}}>{t('Value')}</TableCell>
                                <TableCell style={{...styles.head, width:'15%'}}>{t('Timeout')}</TableCell>
                                <TableCell align='center' style={{...styles.head, width:150}}>{t('Alert')}</TableCell>
                                <TableCell align='center' style={{...styles.head, width:150}}>{t('EmailNotification')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            <TableRow>
                                <TableCell>{t('ProcessorLoad')}</TableCell>
                                <TableCell align='center'>{'>'}</TableCell>
                                <TableCell>
                                    <TextField name="TotalProcessorThreshold" margin="normal" 
                                        hiddenLabel
                                        id="TotalProcessorThreshold"
                                        size="small"
                                        style={{width2:'100%', margin:0}}
                                        autoComplete="new-password"
                                        value={statisticsSettings.TotalProcessorThreshold}
                                        onChange={this.handleInput}
                                        />
                                </TableCell>
                                <TableCell>
                                    <TextField name="TotalProcessorTimeout" margin="normal" 
                                        hiddenLabel
                                        id="TotalProcessorTimeout"
                                        size="small"
                                        style={{width2:'100%', margin:0}}
                                        autoComplete="new-password"
                                        value={statisticsSettings.TotalProcessorTimeout}
                                        onChange={this.handleInput}
                                        />
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.TotalProcessorAlarm}
                                        onChange={this.handleInput}
                                        name="TotalProcessorAlarm"
                                        />
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.TotalProcessorEmail}
                                        onChange={this.handleInput}
                                        name="TotalProcessorEmail"
                                        />
                                </TableCell>
                            </TableRow>


                            <TableRow>
                                <TableCell>{t('FreeMemory')}</TableCell>
                                <TableCell align='center'>{'<'}</TableCell>
                                <TableCell>
                                    <TextField name="TotalMemoryThreshold" margin="normal" 
                                        hiddenLabel
                                        id="TotalMemoryThreshold"
                                        size="small"
                                        style={{width2:'100%', margin:0}}
                                        autoComplete="new-password"
                                        value={statisticsSettings.TotalMemoryThreshold}
                                        onChange={this.handleInput}
                                        />
                                </TableCell>
                                <TableCell>
                                    <TextField name="TotalMemoryTimeout" margin="normal" 
                                        hiddenLabel
                                        id="TotalMemoryTimeout"
                                        size="small"
                                        style={{width2:'100%', margin:0}}
                                        autoComplete="new-password"
                                        value={statisticsSettings.TotalMemoryTimeout}
                                        onChange={this.handleInput}
                                        />
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.TotalMemoryAlarm}
                                        onChange={this.handleInput}
                                        name="TotalMemoryAlarm"
                                        />
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.TotalMemoryEmail}
                                        onChange={this.handleInput}
                                        name="TotalMemoryEmail"
                                        />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>{t('DiskFreeSpace')}</TableCell>
                                <TableCell align='center'>{'<'}</TableCell>
                                <TableCell>
                                    <TextField name="DiskFreeSpaceThreshold" margin="normal" 
                                        hiddenLabel
                                        id="DiskFreeSpaceThreshold"
                                        size="small"
                                        style={{width2:'100%', margin:0}}
                                        autoComplete="new-password"
                                        value={statisticsSettings.DiskFreeSpaceThreshold}
                                        onChange={this.handleInput}
                                        />
                                </TableCell>
                                <TableCell>
                                    <TextField name="DiskFreeSpaceTimeout" margin="normal" 
                                        hiddenLabel
                                        id="DiskFreeSpaceTimeout"
                                        size="small"
                                        style={{width2:'100%', margin:0}}
                                        autoComplete="new-password"
                                        value={statisticsSettings.DiskFreeSpaceTimeout}
                                        onChange={this.handleInput}
                                        />
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.DiskFreeSpaceAlarm}
                                        onChange={this.handleInput}
                                        name="DiskFreeSpaceAlarm"
                                        />
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.DiskFreeSpaceEmail}
                                        onChange={this.handleInput}
                                        name="DiskFreeSpaceEmail"
                                        />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>{t('DiskUsage')}</TableCell>
                                <TableCell align='center'>{'>'}</TableCell>
                                <TableCell>
                                    <TextField name="DiskLoadThreshold" margin="normal" 
                                        hiddenLabel
                                        id="DiskLoadThreshold"
                                        size="small"
                                        style={{width2:'100%', margin:0}}
                                        autoComplete="new-password"
                                        value={statisticsSettings.DiskLoadThreshold}
                                        onChange={this.handleInput}
                                        />
                                </TableCell>
                                <TableCell>
                                    <TextField name="DiskLoadTimeout" margin="normal" 
                                        hiddenLabel
                                        id="DiskLoadTimeout"
                                        size="small"
                                        style={{width2:'100%', margin:0}}
                                        autoComplete="new-password"
                                        value={statisticsSettings.DiskLoadTimeout}
                                        onChange={this.handleInput}
                                        />
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.DiskLoadAlarm}
                                        onChange={this.handleInput}
                                        name="DiskLoadAlarm"
                                        />
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.DiskLoadEmail}
                                        onChange={this.handleInput}
                                        name="DiskLoadEmail"
                                        />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>{t('NetworkUsage')}</TableCell>
                                <TableCell align='center'>{'>'}</TableCell>
                                <TableCell>
                                    <TextField name="NetworkThreshold" margin="normal" 
                                        hiddenLabel
                                        id="NetworkThreshold"
                                        size="small"
                                        style={{width2:'100%', margin:0}}
                                        autoComplete="new-password"
                                        value={statisticsSettings.NetworkThreshold}
                                        onChange={this.handleInput}
                                        />
                                </TableCell>
                                <TableCell>
                                    <TextField name="NetworkTimeout" margin="normal" 
                                        hiddenLabel
                                        id="NetworkTimeout"
                                        size="small"
                                        style={{width2:'100%', margin:0}}
                                        autoComplete="new-password"
                                        value={statisticsSettings.NetworkTimeout}
                                        onChange={this.handleInput}
                                        />
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.NetworkAlarm}
                                        onChange={this.handleInput}
                                        name="NetworkAlarm"
                                        />
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.NetworkEmail}
                                        onChange={this.handleInput}
                                        name="NetworkEmail"
                                        />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>{t('DatabaseSizeMb')}</TableCell>
                                <TableCell align='center'>{'>'}</TableCell>
                                <TableCell>
                                    <TextField name="DatabaseSizeThreshold" margin="normal" 
                                        hiddenLabel
                                        id="DatabaseSizeThreshold"
                                        size="small"
                                        style={{width2:'100%', margin:0}}
                                        autoComplete="new-password"
                                        value={statisticsSettings.DatabaseSizeThreshold}
                                        onChange={this.handleInput}
                                        />
                                </TableCell>
                                <TableCell>
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.DatabaseSizeAlarm}
                                        onChange={this.handleInput}
                                        name="DatabaseSizeAlarm"
                                        />
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.DatabaseSizeEmail}
                                        onChange={this.handleInput}
                                        name="DatabaseSizeEmail"
                                        />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>{t('DmrNetworkDisconnect')}</TableCell>
                                <TableCell align='center'></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.DmrRepeaterDisconnectAlarm}
                                        onChange={this.handleInput}
                                        name="DmrRepeaterDisconnectAlarm"
                                        />
                                </TableCell>
                                <TableCell align='center'>
                                    <Checkbox color="primary" 
                                        checked={statisticsSettings.DmrRepeaterDisconnectEmail}
                                        onChange={this.handleInput}
                                        name="DmrRepeaterDisconnectEmail"
                                        />
                                </TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>

                </ExpansionPanelDetails>
            </ExpansionPanel>


            <ExpansionPanel 
                expanded={this.state.panelsExpanded.SMTP} 
                onChange={(event, expanded) => this.togglePanel(event, expanded, 'SMTP')}>
                <ExpansionPanelSummary style={{backgroundColor: grey[300]}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{t('SMTP')}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{display: 'block'}}>

                    
                    <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                        <Grid container>
                            <Grid item xs={4} style={{...margin2}}>
                                
                            </Grid>
                            <Grid item xs={8} style={{...margin2}}>

                                <FormControl>
                                    <label>
                                        <Checkbox color="primary" 
                                            checked={statisticsSettings.SmtpEnabled}
                                            onChange={this.handleInput}
                                            name="SmtpEnabled"
                                            />
                                            {t('EnableSMTPMessages')}
                                    </label>
                                </FormControl>

                            </Grid>
                        </Grid>
                    </Box>

                    <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                        <Grid container>
                            <Grid item xs={4} style={{...margin2}}>
                                <label htmlFor="SmtpServerAddress">
                                {t('ServerAddress')}
                                </label>
                            </Grid>
                            <Grid item xs={8} style={{...margin2}}>

                                <TextField name="SmtpServerAddress" margin="normal" 
                                    disabled={!statisticsSettings.SmtpEnabled}
                                    hiddenLabel
                                    id="SmtpServerAddress"
                                    size="small"
                                    style={{width2:'100%', margin:0}}
                                    autoComplete="new-password"
                                    value={statisticsSettings.SmtpServerAddress}
                                    onChange={this.handleInput}
                                    />

                            </Grid>
                        </Grid>
                    </Box>

                    <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                        <Grid container>
                            <Grid item xs={4} style={{...margin2}}>
                                <label htmlFor="SmtpServerPort">
                                {t('ServerPort')}
                                </label>
                            </Grid>
                            <Grid item xs={8} style={{...margin2}}>

                                <TextField name="SmtpServerPort" margin="normal" 
                                    disabled={!statisticsSettings.SmtpEnabled}
                                    hiddenLabel
                                    id="SmtpServerPort"
                                    size="small"
                                    style={{width2:'100%', margin:0}}
                                    autoComplete="new-password"
                                    value={statisticsSettings.SmtpServerPort}
                                    onChange={this.handleInput}
                                    />

                            </Grid>
                        </Grid>
                    </Box>

                    <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                        <Grid container>
                            <Grid item xs={4} style={{...margin2}}>
                                
                            </Grid>
                            <Grid item xs={8} style={{...margin2}}>

                                <FormControl>
                                    <label>
                                        <Checkbox color="primary" 
                                            disabled={!statisticsSettings.SmtpEnabled}
                                            checked={statisticsSettings.SmtpEnableSSL}
                                            onChange={this.handleInput}
                                            name="SmtpEnableSSL"
                                            />
                                            {t('EnableSSL')}
                                    </label>
                                </FormControl>

                            </Grid>
                        </Grid>
                    </Box>

                    <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                        <Grid container>
                            <Grid item xs={4} style={{...margin2}}>
                                <label htmlFor="SmtpLogin">
                                {t('Login')}
                                </label>
                            </Grid>
                            <Grid item xs={8} style={{...margin2}}>

                                <TextField name="SmtpLogin" margin="normal" 
                                    disabled={!statisticsSettings.SmtpEnabled}
                                    hiddenLabel
                                    id="SmtpLogin"
                                    size="small"
                                    style={{width2:'100%', margin:0}}
                                    autoComplete="new-password"
                                    value={statisticsSettings.SmtpLogin}
                                    onChange={this.handleInput}
                                    />

                            </Grid>
                        </Grid>
                    </Box>

                    <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                        <Grid container>
                            <Grid item xs={4} style={{...margin2}}>
                                <label htmlFor="SmtpPassword">
                                {t('Password')}
                                </label>
                            </Grid>
                            <Grid item xs={8} style={{...margin2}}>

                                <TextField name="SmtpPassword" margin="normal" 
                                    disabled={!statisticsSettings.SmtpEnabled}
                                    hiddenLabel
                                    type="password"
                                    id="SmtpPassword"
                                    size="small"
                                    style={{width2:'100%', margin:0}}
                                    autoComplete="new-password"
                                    value={statisticsSettings.SmtpPassword}
                                    onChange={this.handleInput}
                                    />

                            </Grid>
                        </Grid>
                    </Box>

                    <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                        <Grid container>
                            <Grid item xs={4} style={{...margin2}}>
                                <label htmlFor="SmtpAccountName">
                                {t('FromName')}
                                </label>
                            </Grid>
                            <Grid item xs={8} style={{...margin2}}>

                                <TextField name="SmtpAccountName" margin="normal" 
                                    disabled={!statisticsSettings.SmtpEnabled}
                                    hiddenLabel
                                    id="SmtpAccountName"
                                    size="small"
                                    style={{width2:'100%', margin:0}}
                                    autoComplete="new-password"
                                    value={statisticsSettings.SmtpAccountName}
                                    onChange={this.handleInput}
                                    />

                            </Grid>
                        </Grid>
                    </Box>

                    <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                        <Grid container>
                            <Grid item xs={4} style={{...margin2}}>
                                <label htmlFor="SmtpAccountAddress">
                                {t('FromAddress')}
                                </label>
                            </Grid>
                            <Grid item xs={8} style={{...margin2}}>

                                <TextField name="SmtpAccountAddress" margin="normal" 
                                    disabled={!statisticsSettings.SmtpEnabled}
                                    hiddenLabel
                                    id="SmtpAccountAddress"
                                    size="small"
                                    style={{width2:'100%', margin:0}}
                                    autoComplete="new-password"
                                    value={statisticsSettings.SmtpAccountAddress}
                                    onChange={this.handleInput}
                                    />

                            </Grid>
                        </Grid>
                    </Box>


                    <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                        <Grid container>
                            <Grid item xs={4} style={{...margin2}}>
                                <label htmlFor="SmtpMessageSubject">
                                {t('AlarmMessageSubject')}
                                </label>
                            </Grid>
                            <Grid item xs={8} style={{...margin2}}>

                                <TextField name="SmtpMessageSubject" margin="normal" 
                                    disabled={!statisticsSettings.SmtpEnabled}
                                    hiddenLabel
                                    id="SmtpMessageSubject"
                                    size="small"
                                    style={{width:'100%', margin:0}}
                                    autoComplete="new-password"
                                    value={statisticsSettings.SmtpMessageSubject}
                                    onChange={this.handleInput}
                                    />

                            </Grid>
                        </Grid>
                    </Box>


                    <Box textAlign="left" style={{...margin,  maxWidth: 600}}>
                        <Grid container>
                            <Grid item xs={4} style={{...margin2}}>
                                <label htmlFor="SmtpMessageToAddress">
                                {t('ToAddressesCommaDelimited')}
                                </label>
                            </Grid>
                            <Grid item xs={8} style={{...margin2}}>

                                <TextField name="SmtpMessageToAddress" margin="normal" 
                                    disabled={!statisticsSettings.SmtpEnabled}
                                    hiddenLabel
                                    id="SmtpMessageToAddress"
                                    size="small"
                                    style={{width:'100%', margin:0}}
                                    autoComplete="new-password"
                                    value={statisticsSettings.SmtpMessageToAddress}
                                    onChange={this.handleInput}
                                    />

                            </Grid>
                        </Grid>
                    </Box>
                    {/**
                     * 
                     * SmtpAccountAddress: ""
​​
SmtpAccountName: ""
​​
SmtpEnableSSL: false
​​
SmtpEnabled: false
​​
SmtpLogin: ""
​​
SmtpMessageSubject: ""
​​
SmtpMessageToAddress: ""
​​
SmtpPassword: ""
​​
SmtpServerAddress: ""
​​
SmtpServerPort: 25
                     */}

                </ExpansionPanelDetails>
            </ExpansionPanel>

                

            </>
        )


    }


    handleTemplateSelect(templateID){
        this.setState({currentTemplateID: templateID})
    }


    fieldTemplatesTab(){

        const fieldTemplateDialog = this.state.fieldTemplateEditor.action?(
            <EditFieldTemplateDialog 
                {...this.state.fieldTemplateEditor} 
                onAction={this.handleAction}/>
        ):'';

        let templates = this.state.serverSettings ? this.state.serverSettings.FieldTemplates : [];

        const list = (
            <>
            <TemplatesListEditor 
                    templates={templates}
                    selectedTemplateID={this.state.currentTemplateID}
                    onTemplateSelect={this.handleTemplateSelect.bind(this)}
                    onAction={this.handleAction} />
            {fieldTemplateDialog} 
            </>
        );


       return list
    }


    render(){
        const {t} = this.props

        let statusMessage = ''
        if(this.props.statusMessage){
            statusMessage = (
            <Typography align="center" color={this.props.statusError ? "error" : "default"}>
                {this.props.statusMessage}
            </Typography>
            );
        }

        let list = ''
        switch(this.state.selectedTab){
            case 'dispatchers':
                console.log('this.state.dispatcherEditor')
                console.log(this.state.dispatcherEditor)
                const dispatcherDialog = this.state.dispatcherEditor.action?(
                    <EditDispatcherDialog 
                        {...this.state.dispatcherEditor} 
                        passwordPolicy={this.state.serverSettings.ServerData.PasswordPolicy}
                        networks={this.props.networks}
                        onAction={this.handleAction}/>
                ):'';

                let dispatchers = this.state.serverSettings ? this.state.serverSettings.Dispatchers : [];

                const passwordPolicyDialog = this.state.passwordPolicyEditor.open ? (
                    <EditPasswordPolicyDialog {...this.state.passwordPolicyEditor} 
                        onAction={this.handleAction} />
                ):'';


                list = (
                    <>
                    <DispatchersListEditor 
                            dispatchers={dispatchers}
                            selectedDispatcherID={this.state.currentDispatcherID}
                            onDispatcherSelect={this.handleDispatcherSelect.bind(this)}
                            onAction={this.handleAction} />
                    {dispatcherDialog} 
                    {passwordPolicyDialog}
                    </>
                );
                break;

            case 'custom':{
                list = this.customTab()
                break;
            }

            case 'device_defaults':
                list = this.deviceDefaultsTab()
                break

            case 'api':
                list = this.apiTab()
                break

            case 'dmr':
                list = this.dmrTab()
                break

            case 'system_monitoring':
                list = this.systemMonitoringTab()
                break

            case 'field_templates':
                list =this.fieldTemplatesTab()
                break;

            default:
                list = (<>Tab action not defined!</>)
                dev.alert(this.state.selectedTab + ' tab action not defined! (render ServerSettings)')
        }

        let dmrEnabled = this.checkLicense('AisDmr') ||
                         this.checkLicense('CalttaDmr') ||
                         this.checkLicense('HyteraDmr') ||
                         this.checkLicense('KirisunDmr')
        //console.log('dmrEnabled')
        //console.log(dmrEnabled)
           
        return (
            <Grid item xs={12} style={{height:'100vh'}}>

                <ApplicationBar user={this.props.user}
                    onAction={this.handleAction}>
                    {/*network ? network.Name : ''*/}
                </ApplicationBar>

                <Grid container key="1" justify="flex-start" spacing={0} style={{height:'83%', borderTop:'1px solid '+theme.palette.border.dialog}} >
                    <Grid xs={12} item style={{}}>
                        <Container height="100vh" style={{padding:0, paddingTop: '1em'}}>

                            <Dialog width="xl" variant="h6" align="left" title={t('ServerSettings')} style={{}}>
                                <Box textAlign="left" style={{paddingBottom: '1em'}}>
                                    <TabbedMenu 
                                        selected={this.state.selectedTab} 
                                        onClick={this.handleTabClick}
                                        onAction={this.props.onAction}
                                        dmrEnabled={dmrEnabled}
                                    ></TabbedMenu>
                                </Box>
                                <Box textAlign="left" style={{paddingBottom: '1em'}}>
                                    {list}
                                </Box>
                                <Box textAlign="center" style={{}}>
                                    <Button variant="contained" color="primary" 
                                        onClick={this.handleButtonSave.bind(this)} 
                                        style={{margin: '0 0.4em'}}>{t('Apply')}</Button>
                                    <Button variant="contained" color="inherit"
                                        onClick={this.handleButtonCancel.bind(this)} 
                                        style={{margin: '0 0.4em'}} >{t('Cancel')}</Button>
                                </Box>
                            </Dialog>

                        </Container>
                    </Grid>
                </Grid>
                <Grid xs={12} key="2" item style={{height:'3em'}}>
                    {statusMessage}{/*Server Status*/}
                </Grid>
            </Grid>
        );
    }
}

export const ServerSettings = withTranslation()(ServerSettings_);